module.exports = __webpack_public_path__ + "static/media/6 Seats 6 Sides (disconnected).72c6e9f7.png";